/* eslint-disable @typescript-eslint/no-explicit-any */
export default {
	name: 'termsPage',
	title: 'Terms & Conditions Page',
	type: 'document',
	fields: [
		{
			name: 'title',
			title: 'Page Title',
			type: 'string',
			validation: (Rule: any) => Rule.required(),
		},
		{
			name: 'header',
			title: 'Header Section',
			type: 'object',
			fields: [
				{
					name: 'title',
					title: 'Header Title',
					type: 'string',
					validation: (Rule: any) => Rule.required(),
					initialValue: 'Terms and Conditions',
				},
				{
					name: 'subtitle',
					title: 'Header Subtitle',
					type: 'text',
					initialValue:
						'Please read these terms and conditions carefully before using our services',
				},
				{
					name: 'backgroundImage',
					title: 'Background Image',
					type: 'image',
					options: {
						hotspot: true,
					},
				},
				{
					name: 'overlayOpacity',
					title: 'Background Overlay Opacity',
					description: 'Value between 0 (transparent) and 100 (opaque)',
					type: 'number',
					validation: (Rule: any) => Rule.min(0).max(100),
					initialValue: 50,
				},
			],
		},
		{
			name: 'introduction',
			title: 'Introduction Text',
			type: 'text',
			description: 'Brief introduction to the terms and conditions',
			initialValue:
				'Last Updated: April 2024. The following terms and conditions govern your use of our services and website.',
		},
		{
			name: 'lastUpdated',
			title: 'Last Updated Date',
			type: 'date',
			description: 'When were the terms last updated',
			options: {
				dateFormat: 'MMMM YYYY',
			},
		},
		{
			name: 'terms',
			title: 'Terms and Conditions',
			type: 'array',
			of: [
				{
					type: 'object',
					name: 'term',
					fields: [
						{
							name: 'title',
							title: 'Title',
							type: 'string',
							validation: (Rule: any) => Rule.required(),
						},
						{
							name: 'content',
							title: 'Content',
							type: 'array',
							of: [{ type: 'block' }],
							validation: (Rule: any) => Rule.required(),
						},
					],
				},
			],
		},
		{
			name: 'footer',
			title: 'Footer Note',
			type: 'text',
			initialValue:
				'By using our services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.',
		},
		{
			name: 'seo',
			title: 'SEO Settings',
			type: 'object',
			fields: [
				{
					name: 'metaTitle',
					title: 'Meta Title',
					type: 'string',
				},
				{
					name: 'metaDescription',
					title: 'Meta Description',
					type: 'text',
				},
			],
		},
	],
	preview: {
		select: {
			title: 'title',
			lastUpdated: 'lastUpdated',
		},
		prepare({ title, lastUpdated }: any) {
			return {
				title,
				subtitle: lastUpdated ? `Last updated: ${lastUpdated}` : '',
			};
		},
	},
};
